import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import AppsIcon from '@mui/icons-material/Apps';

const STOP_PAGE_RE = /^\/(stop|schedule)\//;

function getActiveTab(pathname, panel) {
  if (STOP_PAGE_RE.test(pathname)) return (panel === 'mobilite' || panel === 'contact') ? 1 : 0;
  if (pathname === '/mobilite' || pathname === '/contact' || pathname.startsWith('/mobilite/')) return 1;
  return 0;
}

const actionSx = {
  color: 'rgba(255,255,255,0.4)',
  minWidth: 0,
  py: 1,
  '& .MuiBottomNavigationAction-label': {
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: 0.2,
    opacity: 1,
    mt: 0.25,
  },
  '&.Mui-selected': {
    color: '#4fc3f7',
  },
  '&.Mui-selected .MuiBottomNavigationAction-label': {
    fontSize: '0.65rem',
  },
};

export default function BottomNav() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const panel = searchParams.get('panel') || 'schedule';
  const value = getActiveTab(pathname, panel);
  const onStopPage = STOP_PAGE_RE.test(pathname);

  const handleChange = (_, newValue) => {
    if (onStopPage) {
      if (newValue === 0) setSearchParams({});
      else {
        const last = sessionStorage.getItem('lastMobilitePanel') || 'mobilite';
        setSearchParams({ panel: last });
      }
    } else {
      if (newValue === 0) {
        const lastStop = sessionStorage.getItem('lastStopPath');
        navigate(lastStop || '/');
      } else {
        navigate('/mobilite');
      }
    }
  };

  return (
    <Paper
      elevation={12}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        borderRadius: 0,
      }}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        sx={{
          bgcolor: '#0d1b35',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          height: 60,
        }}
      >
        <BottomNavigationAction
          label={t('nav.busSchedule')}
          icon={<DirectionsBusIcon />}
          sx={actionSx}
        />
        <BottomNavigationAction
          label={t('nav.mobility')}
          icon={<AppsIcon />}
          sx={actionSx}
        />
      </BottomNavigation>
    </Paper>
  );
}
